import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaHome, FaInfoCircle, FaPhone, FaSuitcase, FaUmbrellaBeach } from 'react-icons/fa';
import './Navbar.css';
import Logo from "../assets/logoR.png";
const Navbar = () => {
  const location = useLocation();

  const navItems = [
    { label: 'Home', icon: <FaHome />, path: '/' },
    { label: 'About', icon: <FaInfoCircle />, path: '/about' },
    { label: 'Contact', icon: <FaPhone />, path: '/contact' },
    { label: 'Services', icon: <FaSuitcase />, path: '/services' },
    { label: 'Holiday Packages', icon: <FaUmbrellaBeach />, path: '/holiday-packages' }
  ];

  return (
    <>
      {/* Desktop Navbar */}
      <nav className="navbar desktop-navbar">
        <div className="navbar-logo"><img src={Logo}/></div>
        <ul className="navbar-menu">
          {navItems.map(item => (
            <li key={item.label}>
              <Link to={item.path} className={location.pathname === item.path ? 'active' : ''}>
                {item.label}
              </Link>
            </li>
          ))}
        </ul>
      </nav>

      {/* Mobile Navbar */}
      <nav className="navbar mobile-navbar">
        {navItems.map(item => (
          <Link to={item.path} key={item.label} className={location.pathname === item.path ? 'active' : ''}>
            {item.icon}
          </Link>
        ))}
      </nav>
    </>
  );
};

export default Navbar;
